import React, { useEffect, useRef } from 'react';
import { Select } from 'antd';
const {Option} = Select;
import cuid from '@paralleldrive/cuid2';
// self
import { IHistoricalChartsModel, ITemplateOptionsResModel } from '@/util/Request/agrialert/requestType';
import { AgriAlertClostIcon } from '@/resource/IconComponentSets';
import './index.less';


const ChangeTypeEnum = {
    AGGREGATION: 'Aggregation',
    CHARTSVARIABLES: 'ChartsVariables',
    TIMEPERIOD: 'TimePeriod'
};
const HistoricalChartAggregation = [
    {
        code: 'daily',
        name: 'Daily'
    },
    {
        code: 'weekly',
        name: 'Weekly'
    },
    {
        code: 'monthly',
        name: 'Monthly'
    }
];

interface IProp{
    templateOptions: ITemplateOptionsResModel;
    isDisabled: boolean;
    selectedHistoricalCharts: IHistoricalChartsModel[]
    childChangeSelectedHistoricalCharts?: (updateFn?:any)=>void
}


const HistoricalChartSelect = (prop:IProp)=>{

    const {
        templateOptions,
        isDisabled,
        selectedHistoricalCharts,
        childChangeSelectedHistoricalCharts
    } = prop;

    const publicChangeHistoricalItems = (index: number,type: string,
        aggregationValue?: string, chartVariables?: string[], timePerids?: number)=>{

        childChangeSelectedHistoricalCharts((draft) => {
            if (type === ChangeTypeEnum.AGGREGATION && aggregationValue !== undefined) {
                draft[index].historicalAggregation = aggregationValue;
            } else if (type === ChangeTypeEnum.CHARTSVARIABLES && chartVariables !== undefined) {
                draft[index].historicalVariablesForArray = chartVariables;
                draft[index].historicalVariables = chartVariables.join(';');
            } else if (type === ChangeTypeEnum.TIMEPERIOD && timePerids !== undefined) {
                draft[index].historicalDays = timePerids;
            }
        });
    };

    const addHistoricalChartItem = ()=>{
        const tmpHistoricalChartsItem: IHistoricalChartsModel = {
            sortNumber: selectedHistoricalCharts?.length,
            historicalAggregation: null,
            historicalDays: null,
            historicalVariables: null,
            historicalVariablesForArray: []
        };
        childChangeSelectedHistoricalCharts(draft =>{
            draft.push(tmpHistoricalChartsItem); // 添加新的数据
        });

    };

    const deleteHistoricalChartItem = (index:number)=>{
        childChangeSelectedHistoricalCharts(draft => {
            if (draft.length === 1 && index === 0) {
                draft[0] = {
                    sortNumber: 0,
                    historicalAggregation: null,
                    historicalDays: null,
                    historicalVariables: null,
                    historicalVariablesForArray: []
                };
            } else {
                // 移除指定索引的项目并重新索引剩余项目
                draft.splice(index, 1);
                draft.forEach((item, idx) => {
                    item.sortNumber = idx; // 更新 sortNumber 以反映新的顺序
                });
            }
        });

    };




    return(
        <div className='historicalChartSelect-all-container'>
            <div className='historicalChartSelect-container'>
                {
                    selectedHistoricalCharts?.map((item,index)=>{
                        return(
                            <>
                                <div
                                    className='historicalChartSelect-content-item'
                                    key = {cuid.createId()}
                                >
                                    <div className='item-content'>
                                        <div className='flex-row'>
                                            <div className='select-aggregation'>
                                                <p><span className='red'>*</span>Select Aggregation</p>
                                                <Select
                                                    size='large'
                                                    placeholder='Select Aggregation'
                                                    value={item?.historicalAggregation || null}
                                                    onChange={(e)=>{
                                                        publicChangeHistoricalItems(index,ChangeTypeEnum.AGGREGATION,e,null,null);
                                                    }}
                                                    disabled={isDisabled}
                                                >
                                                    {
                                                        HistoricalChartAggregation.map((optionItem)=>{
                                                            return(
                                                                <>
                                                                    <Option
                                                                        key={cuid.createId()}
                                                                        value = {optionItem?.code?.toString()}
                                                                    >
                                                                        {optionItem?.name}
                                                                    </Option>
                                                                </>
                                                            );
                                                        })
                                                    }
                                                </Select>
                                            </div>
                                            <div className='select-variables'>
                                                <p><span className='red'>*</span>Select Variables</p>
                                                <Select
                                                    disabled={isDisabled}
                                                    className='multiple-select'
                                                    placeholder="Select Variables"
                                                    size='large'
                                                    mode="multiple"
                                                    value={item?.historicalVariablesForArray || []}
                                                    onChange={(e)=>{
                                                        publicChangeHistoricalItems(index,ChangeTypeEnum.CHARTSVARIABLES,null,e,null);
                                                    }}
                                                >
                                                    {templateOptions?.historicalWeatherChartVariables?.sort((a,b)=>{
                                                        if(a.name < b.name) return -1;
                                                        if(a.name > b.name) return 1;
                                                        return 0;
                                                    })?.map((item,index) => (
                                                        <Option
                                                            key = {cuid.createId()}
                                                            value={item.code}>
                                                            {item.name}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </div>
                                        </div>
                                        <div className='flex-row'>
                                            <div className='select-time-period'>
                                                <p><span className='red'>*</span>Select Time Period</p>
                                                <Select
                                                    disabled={isDisabled}
                                                    placeholder="Select Time Period"
                                                    size='large'
                                                    value={item?.historicalDays || null}
                                                    onChange={(e)=>{
                                                        publicChangeHistoricalItems(index,ChangeTypeEnum.TIMEPERIOD,null,null,e);
                                                    }}
                                                >
                                                    {templateOptions?.historicalChartDays?.map((item,index) => (
                                                        <Option
                                                            key = {cuid.createId()}
                                                            value={item.code}>
                                                            {item.name}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className='delete-agronomic'
                                        style={{marginTop: '10px'}}
                                        onClick={()=>{
                                            deleteHistoricalChartItem(index);
                                        }}
                                    >
                                        <AgriAlertClostIcon/>
                                    </div>
                                </div>
                            </>
                        );
                    })
                }

            </div>


            <div className='agronomic-add-button-container'>
                <button
                    className='add-recommendation-button'
                    onClick={()=>{
                        addHistoricalChartItem();
                    }}
                >+ Add another Historical Chart</button>
            </div>

        </div>
    );
};

export default HistoricalChartSelect;